// extracted by mini-css-extract-plugin
export var completionBody = "_fd-2";
export var completionCard = "_fd-0";
export var completionFooter = "_fd-3";
export var completionTitle = "_fd-1";